<template>
  <div class="app">
    <h1>代理记账_记账报税_注册公司_人事社保_名企科技</h1>
    <Header :activeIndex="'1'" />

    <!-- 轮播图 -->
    <div class="carousel">
      <el-carousel class="responsive-carousel" :height="imgHeight">
        <el-carousel-item>
          <img :src="require('../assets/img/img_1.png')"
            alt="专业财务服务平台，名企科技始于2017年，专业、规范、诚信、高效，服务热线：010-84922330,13910303798" class="carousel-image" ref="imgHeight"
            @load="imgLoad">
        </el-carousel-item>
        <el-carousel-item>
          <img :src="require('../assets/img/img_2.png')"
            alt="注册公司、代理记账，增资减资、刻章开户，注册地址、变更注销，资质许可、社保托管，电话：101-84922330，名企科技：品质服务，专业高效" class="carousel-image"
            ref="imgHeight" @load="imgLoad">
        </el-carousel-item>
      </el-carousel>
    </div>

    <!-- 我们的热门服务 -->
    <div class="popularSer">
      <!-- <span class="minePopular">热门服务🔥<a href="./font">字体</a></span> -->
      <span class="minePopular">热门服务🔥</span>
      <div class="serviceContainer">
        <div class="service1" @click="pathgongshang">
          注&nbsp;册<br>公&nbsp;司
        </div>
        <div class="service2" @click="pathJizhang">
          代&nbsp;理<br>记&nbsp;账
        </div>
        <div class="service2" @click="pathgongshang">
          工&nbsp;商<br>变&nbsp;更
        </div>
        <div class="service2" @click="pathrenshi">
          人&nbsp;事<br>社&nbsp;保
        </div>
      </div>
      <div class="serviceContainer">
        <div class="service1" @click="pathgongshang">
          解&nbsp;除<br>异&nbsp;常
        </div>
        <div class="service2" @click="pathgongshang">
          清&nbsp;算<br>注&nbsp;销
        </div>
        <div class="service2" @click="pathzhichan">
          知&nbsp;识<br>产&nbsp;权
        </div>
        <div class="service2" @click="pathxuke">
          资&nbsp;质<br>许&nbsp;可
        </div>
      </div>
    </div>

    <!-- 我们的服务优势 -->
    <div class="popularSer">
      <span class="minePopular">我们的服务优势👍</span>
      <div class="fuwuyoushi">
        <div class="box">
          <div class="ziyuanheight">
            <div class="goodtitle">资源&nbsp;更丰富</div>
          </div>
          <ul class="goodtext">
            <li>地址、工商、税务</li>
            <li>优质解决方案</li>
          </ul>
        </div>
        <div class="box">
          <div class="ziyuanheight">
            <div class="goodtitle">服务&nbsp;更专业</div>
          </div>
          <ul class="goodtext">
            <li>会计、人事、客服</li>
            <li>团队服务有保障</li>
          </ul>
        </div>
      </div>
      <div style="display:flex;justify-content: center;text-align: left;">
        <div class="box">
          <div class="ziyuanheight">
            <div class="goodtitle">经验&nbsp;更全面</div>
          </div>
          <ul class="goodtext">
            <li>上千家企业案例</li>
            <li>解决问题轻车熟路</li>
          </ul>
        </div>
        <div class="box">
          <div class="ziyuanheight">
            <div class="goodtitle">老板&nbsp;更放心</div>
          </div>
          <ul class="goodtext">
            <li>管理规范&nbsp;流程明晰</li>
            <li>认真做事&nbsp;诚信负责</li>
          </ul>
        </div>
      </div>
    </div>

    <!-- 腰线 -->
    <div v-if="!isMobile">
      <div class="yaoxianda">
        <div>
          <div class="biaoti">名企科技</div>
          <div class="quanfangwei">全方位的<span style="font-weight:600;">工商代办</span>,真正的<span style="font-weight:600;">服务
            </span> <span class="fangxin">"放心"</span></div>
          <div style="display:flex;margin-top:5px;">
            <div>
              <div class="duigou"><span style="color:red;">√ 专业</span>团队服务，更专业</div>
              <div class="duigou1"><span style="color:red;">√ 高效</span>经验丰富，更高效</div>
            </div>
            <div class="duichen">
              <div class="duigou"><span style="color:red;">√ 规范</span>管理，工作质量有保障</div>
              <div class="duigou1"><span style="color:red;">√ 放心</span>注册、开票、社保全托管</div>
            </div>
          </div>
        </div>
        <div>
          <div class="rexian">服务热线：<span class="shoujihao">1391 0303 798</span></div>
        </div>
        <div class="hongdise">
          <div>名企科技</div>
          <div>工商注册</div>
          <div>代理记账</div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="yaoxianda">
        <div>
          <div class="biaoti">财务服务，就找名企科技！</div>
          <div class="quanfangwei">全方位的<span style="font-weight:600;">工商代办</span>,真正的<span style="font-weight:600;">服务
            </span> <span class="fangxin">"放心"！</span></div>
          <div style="display:flex;margin-top:4px;">
            <div>
              <div class="duigou"><span style="color:red;font-weight:700;">√ 专业</span>团队服务，更专业</div>
              <div class="duigou1"><span style="color:red;font-weight:700;">√ 高效</span>经验丰富，更高效</div>
            </div>
            <div class="duichen">
              <div class="duigou"><span style="color:red;font-weight:700;">√ 规范</span>管理，质量有保障</div>
              <div class="duigou1"><span style="color:red;font-weight:700;">√ 放心</span>托管，安全又可靠</div>
            </div>
          </div>
        </div>
        <div class="hongdise">
          <div>名企科技</div>
          <div>工商注册</div>
          <div>代理记账</div>
          <div>服务热线:</div>
          <div>1391 0303 798</div>
        </div>
      </div>
    </div>

    <!-- 成功案例 -->
    <div class="popularSer">
      <span class="minePopular">成功案例🏆</span>
      <div>
        <div v-if="!isMobile" class="carouselcard">
          <div class="succ">
            <div class="success1">
              <img loading="lazy" class="carousel-imagecard" :src="require('../assets/img/lun_1.jpg')" alt="注册公司 代办营业执照">
              <div class="text4">注册公司 代办营业执照</div>
            </div>
            <div class="success">
              <img loading="lazy" class="carousel-imagecard" :src="require('../assets/img/lun_4.jpg')" alt="代理记账、报税">
              <div class="text4">代理记账、报税</div>
            </div>
            <div class="success">
              <img loading="lazy" class="carousel-imagecard" :src="require('../assets/img/lun_3.jpg')" alt="工商变更 股权转让">
              <div class="text4">工商变更 股权转让</div>
            </div>
            <div class="success">
              <img loading="lazy" class="carousel-imagecard" :src="require('../assets/img/lun_5.jpg')" alt="刻章服务">
              <div class="text4">刻章服务</div>
            </div>
            <div class="success">
              <img loading="lazy" class="carousel-imagecard" :src="require('../assets/img/lun_7.jpg')" alt="公司清算、注销">
              <div class="text4">公司清算、注销</div>
            </div>
            <div class="success">
              <img loading="lazy" class="carousel-imagecard" :src="require('../assets/img/lun_2.jpg')" alt="注册商标">
              <div class="text4">注册商标</div>
            </div>
          </div>

          <div class="succ1">
            <div class="success1">
              <img loading="lazy" class="carousel-imagecard" :src="require('../assets/img/lun_9.jpg')" alt="增值电信业务许可证 ICP、EDI">
              <div class="text2">增值电信业务许可证 ICP、EDI</div>
            </div>
            <div class="success">
              <img loading="lazy" class="carousel-imagecard" :src="require('../assets/img/lun_8.jpg')" alt="食品经营许可证">
              <div class="text3">食品经营许可证</div>
            </div>
            <div class="success">
              <img loading="lazy" class="carousel-imagecard" :src="require('../assets/img/lun_10.jpg')" alt="出版物经营许可证">
              <div class="text3">出版物经营许可证</div>
            </div>
            <div class="success">
              <img loading="lazy" class="carousel-imagecard" :src="require('../assets/img/lun_11.jpg')" alt="认证体系 质量、环境、职业健康">
              <div class="text3">三体系认证、质量认证</div>
            </div>
            <div class="success">
              <img loading="lazy" class="carousel-imagecard" :src="require('../assets/img/lun_12.jpg')" alt="软件著作权证书">
              <div class="text3">软件著作权证书</div>
            </div>
            <div class="success">
              <img loading="lazy" class="carousel-imagecard" :src="require('../assets/img/lun_6.jpg')" alt="进出口许可证">
              <div class="text3">进出口许可证</div>
            </div>
          </div>
        </div>
        <div v-else class="carouselcard">
          <div class="succ">
            <div class="success1">
              <!-- <img :src="require('../assets/img/lun_1.jpg')" data-original="img/example.jpg"> -->
              <img loading="lazy" class="carousel-imagecard" :src="require('../assets/img/lun_1.jpg')" alt="注册公司 代办营业执照">
              <div class="text4">注册公司<br>代办营业执照</div>
            </div>
            <div class="success">
              <img loading="lazy" class="carousel-imagecard" :src="require('../assets/img/lun_4.jpg')" alt="代理记账、报税">
              <div class="text4">代理记账、报税</div>
            </div>
            <div class="success">
              <img loading="lazy" class="carousel-imagecard" :src="require('../assets/img/lun_3.jpg')" alt="工商变更 股权转让">
              <div class="text4">工商变更<br>股权转让</div>
            </div>
            <div class="success">
              <img loading="lazy" class="carousel-imagecard" :src="require('../assets/img/lun_5.jpg')" alt="刻章服务">
              <div class="text4">刻章服务</div>
            </div>
          </div>

          <div class="succ1">
            <div class="success1">
              <img loading="lazy" class="carousel-imagecard" :src="require('../assets/img/lun_7.jpg')" alt="公司清算、注销">
              <div class="text3">公司清算、注销</div>
            </div>
            <div class="success">
              <img loading="lazy" class="carousel-imagecard" :src="require('../assets/img/lun_2.jpg')" alt="注册商标">
              <div class="text3">注册商标</div>
            </div>
            <div class="success">
              <img loading="lazy" class="carousel-imagecard" :src="require('../assets/img/lun_9.jpg')" alt="增值电信业务许可证 ICP、EDI">
              <div class="text3">增值电信业务许可证 ICP、EDI</div>
            </div>
            <div class="success">
              <img loading="lazy" class="carousel-imagecard" :src="require('../assets/img/lun_8.jpg')" alt="食品经营许可证">
              <div class="text3">食品经营许可证</div>
            </div>
          </div>

          <div class="succ1">
            <div class="success1">
              <img loading="lazy" class="carousel-imagecard" :src="require('../assets/img/lun_10.jpg')" alt="出版物经营许可证">
              <div class="text3">出版物经营许可证</div>
            </div>
            <div class="success">
              <img loading="lazy" class="carousel-imagecard" :src="require('../assets/img/lun_11.jpg')" alt="认证体系 质量、环境、职业健康">
              <div class="text3">三体系认证、质量认证</div>
            </div>
            <div class="success">
              <img loading="lazy" class="carousel-imagecard" :src="require('../assets/img/lun_12.jpg')" alt="软件著作权证书">
              <div class="text3">软件著作权证书</div>
            </div>
            <div class="success">
              <img loading="lazy" class="carousel-imagecard" :src="require('../assets/img/lun_6.jpg')" alt="进出口许可证">
              <div class="text3">进出口许可证</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 我们的客户 -->
    <div class="popularSer">
      <span class="minePopular">我们的客户👤</span>
      <div class="juzhong">
        <div class="kehu">
          <div>
            <div class="dazi">
              小型企业
            </div>
            <div class="zuoer">
              <ul style="list-style-type: none;">
                <li>♢ 初创公司</li>
                <li>♢ 小微企业</li>
              </ul>
            </div>
          </div>
          <div class="youyi">
            <ul>
              <li>注册执照、刻章</li>
              <li>代理记账、报税</li>
              <li>发票、社保托管</li>
            </ul>
          </div>
        </div>
        <div class="kehu1">
          <div>
            <div class="dazi">
              中型公司
            </div>
            <div class="zuoer">
              <ul style="list-style-type: none;">
                <li>♢ A、B轮公司</li>
                <li>♢ 事业单位</li>
              </ul>
            </div>
          </div>
          <div class="youyi">
            <ul>
              <li>记账报税</li>
              <li>财务梳理、优化</li>
              <li>办理资质、许可</li>
            </ul>
          </div>
        </div>
        <div class="kehu1">
          <div>
            <div class="dazi">
              大型公司
            </div>
            <div class="zuoer">
              <ul style="list-style-type: none;">
                <li>♢ 上市公司</li>
                <li>♢ 国有企业</li>
              </ul>
            </div>
          </div>
          <div class="youyi">
            <ul>
              <li>工商、税务服务</li>
              <li>办理资质、许可</li>
              <li>财务梳理、优化</li>
            </ul>
          </div>
        </div>
      </div>

    </div>

    <!-- 腰线 -->
    <div class="yaoxianda1">
      <div class="hongdise1">
        <div>名企科技</div>
        <div>工商注册</div>
        <div>代理记账</div>
      </div>
      <div>
        <div class="quanfangwei2">服务热线：</div>
        <div class="quanfangwei1">1391 0303 798</div>
      </div>
      <div class="kuandu">
        <div class="biaoti1">名企财务-更专业，</div>
        <div class="biaoti2">更高效，更规范！</div>
      </div>
    </div>

    <!-- 客户怎么说 -->
    <div class="popularSer">
      <span class="minePopular">客户的肯定🥇</span>
      <div v-if="!isMobile" style="margin-top:6px;">
        <div  class="succ">
          <div class="success1">
            <img loading="lazy" class="carousel-imagecard" :src="require('../assets/img/qi_1.jpg')" alt="表扬：热情周到👍">
            <div class="text">表扬：热情周到👍</div>
          </div>
          <div class="success">
            <img loading="lazy" class="carousel-imagecard" :src="require('../assets/img/qi_2.jpg')" alt="表扬：真诚服务👍">
            <div class="text">表扬：真诚服务👍</div>
          </div>
          <div class="success">
            <img loading="lazy" class="carousel-imagecard" :src="require('../assets/img/qi_3.jpg')" alt="表扬：爱岗敬业👍">
            <div class="text">表扬：爱岗敬业👍</div>
          </div>
          <div class="success">
            <img loading="lazy" class="carousel-imagecard" :src="require('../assets/img/qi_4.jpg')" alt="表扬：信守承诺👍">
            <div class="text">表扬：信守承诺👍</div>
          </div>
          <div class="success">
            <img loading="lazy" class="carousel-imagecard" :src="require('../assets/img/qi_5.jpg')" alt="表扬：办事高效👍">
            <div class="text">表扬：办事高效👍</div>
          </div>
          <div class="success">
            <img loading="lazy" class="carousel-imagecard" :src="require('../assets/img/qi_6.jpg')" alt="表扬：追求卓越👍">
            <div class="text">表扬：追求卓越👍</div>
          </div>
        </div>

        <div class="succ1">
          <div class="success1">
            <img loading="lazy" class="carousel-imagecard" :src="require('../assets/img/qi_7.jpg')" alt="表扬：优质服务👍">
            <div class="text1">表扬：优质服务👍</div>
          </div>
          <div class="success">
            <img loading="lazy" class="carousel-imagecard" :src="require('../assets/img/qi_8.jpg')" alt="表扬：服务高效👍">
            <div class="text1">表扬：服务高效👍</div>
          </div>
          <div class="success">
            <img loading="lazy" class="carousel-imagecard" :src="require('../assets/img/qi_9.jpg')" alt="表扬：技高心细👍">
            <div class="text1">表扬：技高心细👍</div>
          </div>
          <div class="success">
            <img loading="lazy" class="carousel-imagecard" :src="require('../assets/img/qi_10.jpg')" alt="表扬：真情服务👍">
            <div class="text1">表扬：真情服务👍</div>
          </div>
          <div class="success">
            <img loading="lazy" class="carousel-imagecard" :src="require('../assets/img/qi_11.jpg')" alt="表扬：专业高效👍">
            <div class="text1">表扬：专业高效👍</div>
          </div>
          <div class="success">
            <img loading="lazy" class="carousel-imagecard" :src="require('../assets/img/qi_12.jpg')" alt="表扬：热心真诚👍">
            <div class="text1">表扬：热心真诚👍</div>
          </div>
        </div>
      </div>
      <div v-else style="margin-top:5px;">
        <div class="succ">
          <div class="success1">
            <img loading="lazy" class="carousel-imagecard" :src="require('../assets/img/qi_1.jpg')" alt="表扬：热情周到👍">
            <div class="text">热情周到👍</div>
          </div>
          <div class="success">
            <img loading="lazy" class="carousel-imagecard" :src="require('../assets/img/qi_2.jpg')" alt="表扬：真诚服务👍">
            <div class="text">真诚服务👍</div>
          </div>
          <div class="success">
            <img loading="lazy" class="carousel-imagecard" :src="require('../assets/img/qi_3.jpg')" alt="表扬：爱岗敬业👍">
            <div class="text">爱岗敬业👍</div>
          </div>
          <div class="success">
            <img loading="lazy" class="carousel-imagecard" :src="require('../assets/img/qi_4.jpg')" alt="表扬：信守承诺👍">
            <div class="text">信守承诺👍</div>
          </div>
        </div>

        <div class="succ1">
          <div class="success1">
            <img loading="lazy" class="carousel-imagecard" :src="require('../assets/img/qi_5.jpg')" alt="表扬：办事高效👍">
            <div class="text">办事高效👍</div>
          </div>
          <div class="success">
            <img loading="lazy" class="carousel-imagecard" :src="require('../assets/img/qi_6.jpg')" alt="表扬：追求卓越👍">
            <div class="text">追求卓越👍</div>
          </div>
          <div class="success">
            <img loading="lazy" class="carousel-imagecard" :src="require('../assets/img/qi_7.jpg')" alt="表扬：优质服务👍">
            <div class="text1">优质服务👍</div>
          </div>
          <div class="success">
            <img loading="lazy" class="carousel-imagecard" :src="require('../assets/img/qi_8.jpg')" alt="表扬：服务高效👍">
            <div class="text1">服务高效👍</div>
          </div>
        </div>

        <div class="succ1">
          <div class="success1">
            <img loading="lazy" class="carousel-imagecard" :src="require('../assets/img/qi_9.jpg')" alt="表扬：技高心细👍">
            <div class="text1">技高心细👍</div>
          </div>
          <div class="success">
            <img loading="lazy" class="carousel-imagecard" :src="require('../assets/img/qi_10.jpg')" alt="表扬：真情服务👍">
            <div class="text1">真情服务👍</div>
          </div>
          <div class="success">
            <img loading="lazy" class="carousel-imagecard" :src="require('../assets/img/qi_11.jpg')" alt="表扬：专业高效👍">
            <div class="text1">专业高效👍</div>
          </div>
          <div class="success">
            <img loading="lazy" class="carousel-imagecard" :src="require('../assets/img/qi_12.jpg')" alt="表扬：热心真诚👍">
            <div class="text1">热心真诚👍</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 新闻 -->
    <div class="popularSer">
      <span class="minePopular">老板学院<i class="el-icon-key"></i></span>
      <div class="newInfo">
        <div class="index_ans01">
          <div class="index_ans02">
            <div class="gengduo" @click="pathxueyuan">更多>>>
            </div>
            <table class="tableCSS">
              <tbody>
                <tr v-for="(news, index) in newsList" :key="news.id">
                  <td class="tdCSS1">{{ news.createTime }}</td>
                  <td class="tdCSS">
                    <a style="cursor: pointer;" @click="handleClick(news.id)">{{
                      news.title }}</a>
                  </td>
                  <td class="tdCSS">
                    <!-- <a class="look" @click="handleClick(news.content, news.id)" title="查 看">查 看</a> -->
                    <a class="look" @click="handleClick(news.id)" title="查 看">查 看</a>
                  </td>
                </tr>
              </tbody>
            </table>
            <div class="yema">
              <el-pagination layout="prev, pager, next, total" :total="total" :page-size="5" ref="pagination"
                @current-change="handleCurrentChange">
              </el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 底  -->
    <Footer />
  </div>
</template>

<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'

export default {
  name: 'index',
  components: {
    Header,
    Footer
  },
  data() {
    return {
      intervalID: '',
      newMessage: '',
      randomString: '',
      tableData: [],
      imgCount: 0,
      currentIndex: 0,
      currentPosition: 0,
      animationFrame: null,
      isshow: false,
      username: '',
      password: '',
      errorMessage: '',
      token: localStorage.getItem('token') || '',
      newsList: [],
      currentPage: 1,
      total: 0,
      imgHeight: '',
      cardbannerHeight: 0,
      formattedCreateTime: "",
      pppclose: true,
      beforefont: '',
      isMobile: true
    }
  },
  destroyed() {
    window.onresize = null;
  },
  mounted() {
    this.fetchNews();
    this.$root.showData.showData = false;
    this.imgLoad()
    window.onresize = () => {
      this.imgLoad()
    }
    this.cardbannerHeight = window.innerWidth <= 768 ? '180' : '390'
    window.scrollTo(0, 0);
    this.checkScreenSize(); // 初始化时检查屏幕大小
    window.addEventListener('resize', this.checkScreenSize); // 监听窗口大小变化
  },
  beforeDestroy() {
    // 移除全局点击事件监听
    window.removeEventListener('resize', this.checkScreenSize);
  },
  methods: {
    checkScreenSize() {
      this.isMobile = window.innerWidth <= 768; // 根据屏幕宽度判断是否是移动端
    },
    imgLoad() {
      this.$nextTick(() => {
        const imgElement = this.$refs.imgHeight;
        if (imgElement && imgElement.height) {
          this.imgHeight = imgElement.height + 'px';
        }
      });
    },
    pppopco() {
      this.$root.ppp.ppp = !this.$root.ppp.ppp
    },
    updateHeight() {
      // 通过计算属性更新height
      this.$forceUpdate();
    },
    handleClick(id) {
      const contentPageUrl = this.$router.resolve({ name: 'xinwen' }).href;
      const urlWithId = `${contentPageUrl}?id=${id}`;

      // 在新标签页打开带 id 的 URL
      window.open(urlWithId, '_blank');
    },
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage
      this.fetchNews()
    },
    fetchNews() {
      // 假设这里是你的后端接口
      fetch(`https://mingqicaiwu.com:8201/admin/news/getTitle/${this.currentPage}/5`)
        .then(response => response.json())
        .then(data => {
          this.total = data.data.total
          this.newsList = data.data.listPage.records
        })
        .catch(error => {
          alert("查询失败，请重新刷新")
          console.error("分页查询出错，原因是", error);
        })
    },
    handleSelect(key, keyPath) {
      console.log(key, keyPath)
    },
    pathRemen() {
      this.$router.push('/remen')
    },
    pathIndex() {
      this.$router.push('/');
    },
    pathCompanyReg() {
      this.$router.push('/zhuce')
    },
    pathJizhang() {
      this.$router.push('/jizhang')
    },
    pathgongshang() {
      this.$router.push('/gongshang')
    },
    pathshuiwu() {
      this.$router.push('/shuiwu');
    },
    pathzhichan() {
      this.$router.push('/zhichan')
    },
    pathxuke() {
      this.$router.push('/xuke')
    },
    pathrenshi() {
      this.$router.push('/renshi')
    },
    pathxueyuan() {
      this.$router.push('/xueyuan');
    },
    pathabout() {
      this.$router.push('/about')
    },
    pathcontact() {
      this.$router.push('/contact')
    },
    // 
  },
}
</script>

<style>
.el-menu.el-menu--horizontal {
  border-bottom: none !important;
}

.el-carousel__button {
  background-color: #000 !important;
}

.el-menu-item.is-active {
  background-color: #b30101 !important;
}

.el-menu--horizontal>.el-menu-item {
  float: left;
  height: 45px !important;
  line-height: 45px !important;
  margin: 0;
}

@media (max-width: 768px) {
.el-carousel__indicator--horizontal{
  display: inline-block;
    padding: 5px 4px !important;
}
 
  .responsive-carousel el-carousel el-carousel--horizontal {
    width: 100%;
  }

  .el-carousel__indicators el-carousel__indicators--horizontal {
    margin-top: 15px !important
  }

  .el-pager li {
    padding: 0 0px !important;
    min-width: 25.5px !important;
  }

  .el-menu--horizontal>.el-menu-item {
    height: 30px !important;
    line-height: 30px !important;
  }

}
</style>


<style scoped>
/* 大轮播图样式 */
.responsive-carousel {
  width: 100%;
}

.carousel-image {
  width: 100%;
  height: auto;
  object-fit: contain;
}

.carousel {
  margin-top: 107px;
}

/* 热门服务 */
.popularSer {
  margin-top: 4vh;
  margin-left: auto;
  margin-right: auto;
  text-align: center;
}

.minePopular {
  font-size: 35px;
  font-weight: 400;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

.minePopular1 {
  font-size: 35px;
  font-weight: 400;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}


.serviceContainer {
  display: flex;
  margin-top: 6px;
  justify-content: center;
}

.service1 {
  width: 180px;
  height: 170px;
  background-color: #fddbdb;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 30px;
  cursor: pointer;
  font-weight: 700;
}

.service1:hover {
  width: 180px;
  height: 170px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 30px;
  cursor: pointer;
  font-weight: 700;
  background-color: #d22525;
  /* 悬浮时背景颜色 */
  color: #fff;
  /* 悬浮时文字颜色 */
}

.service2 {
  width: 180px;
  height: 170px;
  background-color: #fddbdb;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 30px;
  margin-left: 6px;
  font-weight: 700;
  cursor: pointer;
}

.service2:hover {
  width: 180px;
  height: 170px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 30px;
  cursor: pointer;
  font-weight: 700;
  background-color: #d22525;
  /* 悬浮时背景颜色 */
  color: #fff;
  /* 悬浮时文字颜色 */
}


/* 服务优势 */
.fuwuyoushi {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: left;
  margin-top: 6px;
}

.box {
  width: 370px;
  height: 225px;
  background-color: #037dfb91;
  margin-left: 6px;
  margin-top: 6px;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.ziyuanheight {
  height: 80px;
}

.goodtitle {
  font-size: 30px;
  color: #fdfcb8;
  /* font-family: 'fangzheng', sans-serif; */
  font-family:Impact, Haettenschweiler, 'Arial Narrow Bold', sans-serif;
  font-weight: 550;
  transform: scaleX(1.2) scaleY(2.5);
  line-height: 92px;
}

.goodtext {
  font-size: 23px;
  color: #fdfcb8;
  /* font-family: 'fangzheng', sans-serif; */
  font-family:Impact, Haettenschweiler, 'Arial Narrow Bold', sans-serif;
  margin-top: 15px;
}


/* 腰线 */
.yaoxianda {
  width: 100%;
  height: 175px;
  background-color: #000;
  color: white;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 40px;
  margin-top: 8vh;
  text-align: left;
}

.biaoti {
  font-weight: 700;
  font-size: 25px;
}

.quanfangwei {
  font-weight: 500;
  font-size: 20px;
  margin-top: -7px;
}

.fangxin {
  font-size: 28px;
  color: red;
}

.duigou {
  font-size: small;
}

.duigou1 {
  font-size: small;
  margin-top: 5px;
}

.duichen {
  margin-left: 45px;
}

.rexian {
  font-size: 20px;
}

.shoujihao {
  font-size: 25px;
  font-weight: 700;
}

.hongdise {
  background-color: #b30101;
  color: white;
  font-size: 25px;
  font-weight: 700;
  width: 180px;
  height: 175px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-family:Impact, Haettenschweiler, 'Arial Narrow Bold', sans-serif;
  /* font-family: 'msyhbd', sans-serif; */
}

/* 腰线1 */
.yaoxianda1 {
  width: 100%;
  height: 175px;
  background-color: #000;
  color: white;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 30px;
  margin-top: 8vh;
  text-align: left;
}

.hongdise1 {
  background-color: #b30101;
  color: white;
  font-size: 25px;
  font-weight: 700;
  width: 180px;
  height: 175px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  /* font-family: 'msyhbd', sans-serif; */
  font-family:Impact, Haettenschweiler, 'Arial Narrow Bold', sans-serif;
}

.quanfangwei2 {
  font-weight: 500;
  font-size: 20px;
  margin-top: -7px;
}

.quanfangwei1 {
  font-weight: 900;
  font-size: 30px;
  margin-top: 10px;
}

.kuandu {
  height: 83px;
  display: flex;
  align-items: center;
  /* 水平居中 */
  margin-top: -6px;
}


.biaoti1 {
  font-size: 25px;
  font-weight: 900;
  transform: scaleX(1.5) scaleY(3);
  margin-left: 63px;
  color: #ff0000;
  /* font-family: 'msyhbd', sans-serif; */
  font-family:Impact, Haettenschweiler, 'Arial Narrow Bold', sans-serif;
  width: 244px;
}

.biaoti2 {
  /* font-family: 'msyhbd', sans-serif; */
  font-family:Impact, Haettenschweiler, 'Arial Narrow Bold', sans-serif;
  font-size: 25px;
  ;
  font-weight: 900;
  transform: scaleX(1.5) scaleY(3);
  margin-left: 60px;
  color: #ff0000;
  width: 237px;
}


/* 我们的客户 */
.juzhong {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 6px;
}

.kehu:hover .dazi,
.kehu:hover .zuoer,
.kehu:hover .youyi,
.kehu1:hover .dazi,
.kehu1:hover .zuoer,
.kehu1:hover .youyi {
  border-color: #c9c9c9;
}

/* 保持其他已有样式 */
.kehu,
.kehu1 {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
}

.kehu1 {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 50px;
}

.dazi {
  height: 99px;
  width: 130px;
  border: 6px solid #d22525;
  font-size: 27px;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  border-top-left-radius: 10px;
}

.zuoer {
  height: 72px;
  width: 130px;
  border-left: 6px solid #d22525;
  border-right: 6px solid #d22525;
  border-bottom: 6px solid #d22525;
  font-size: 18px;
  margin-top: 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom-left-radius: 10px;
  flex-direction: column;
  text-align: left;
}

.youyi {
  height: 177px;
  width: 153px;
  border-top: 6px solid #d22525;
  border-right: 6px solid #d22525;
  border-bottom: 6px solid #d22525;
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
  flex-direction: column;
  text-align: left;
}


.fangkuai {
  list-style-type: square;
  margin-top: 0px;
  padding-left: 10px;
}

.yuanquan {
  list-style-type: circle;
}

ul,
li {
  margin: 0;
  padding: 0;
}

/* 成功案例 */

.carouselcard {
  margin-top: 6px;
}

.succ {
  display: flex;
  justify-content: center;
  align-items: center;
  color: #535353;
}

.succ1 {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 5px;
  color: #535353;
}

.carousel-imagecard {
  width: 175px;
  height: 220px;
  object-fit: fill;
  margin-left: 5px;
  display: block;
}

.text {
  font-weight: 700;
  margin-top: 5px;
  margin-bottom: 10px;
  font-size: 14.5px;
}

.text1 {
  font-weight: 700;
  margin-top: 5px;
  margin-bottom: 15px;
  font-size: 14.5px;
}

.text4 {
  font-weight: 700;
  margin-top: 5px;
  margin-bottom: 10px;
  font-size: 14.5px;
}

.text3 {
  font-weight: 700;
  margin-top: 5px;
  margin-bottom: 15px;
  font-size: 14.5px;
}

.text2 {
  font-weight: 700;
  margin-top: 5px;
  margin-bottom: 15px;
  font-size: 13px;
  line-height: 21px;
}

/* 客户的肯定 */
.kehudegood {
  height: 220px;
  width: 190px;
  margin-left: 5px;
}


/* 新闻 */
.newInfo {
  background-image: url(../assets/img/newInfo.jpg);
  background-repeat: no-repeat;
  background-position: top center;
  background-size: 1550px 400px;
}

.index_ans01 {
  width: 690px;
  margin: 0 auto;
  height: 400px;
}

.index_ans02 {
  text-align: center;
  padding-top: 1px;
}

.gengduo {
  text-align: right;
  margin-top: 15px;
  cursor: pointer;
}

.look {
  display: block;
  width: 65px;
  height: 25px;
  line-height: 25px;
  text-align: center;
  background: #d42828;
  color: #fff;
  font-size: 14px;
  border-radius: 12px;
  cursor: pointer;
}

.yema {
  margin-top: 10px;
  margin-left: auto;
  margin-right: auto;
}

.tableCSS {
  width: 690px;
  overflow: hidden;
  /* height: 207px; */
  margin-top: 10px;
  border: 1px solid #ddd;
  border-collapse: collapse;
}

.tdCSS1 {
  width: 84px;
  padding: 8px;
  text-align: center;
  border: none;
  font-size: 19px;
  color: #d22525;
  font-weight: 700;
}

.tdCSS {
  padding: 8px;
  text-align: left;
  border: none;
  font-size: 15px;
}

/* 其他 */
h1 {
  font-size: 0%;
}


@media (max-width: 768px) {

  /* 轮播图 */
  .carousel {
    /* height: auto; */
    margin-top: 90px !important;
    width: 100% !important;
  }

  .el-carousel__item {
    width: 100vw;
    height: auto;
    object-fit: contain;
    display: block;
  }

  .carousel-image {
    width: 100%;
    height: auto;
    object-fit: contain;
    display: block;
  }


  /* 热门服务 */
  .popularSer {
    margin-top: 8px;
    margin-left: auto;
    margin-right: auto;
    text-align: center;
  }

  .minePopular {
    font-size: 18px !important;
    font-weight: 700;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    margin-top: 5px;
  }

  .minePopular1 {
    transform: scaleX(1);
    font-size: 18px !important;
    font-weight: 400;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  }

  .serviceContainer {
    margin-top: 5px;
  }

  .service1 {
    width: 90px !important;
    height: 85px !important;
    background-color: #fddbdb;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 15px !important;
    cursor: pointer;
  }

  .service1:hover {
    width: 90px !important;
    height: 85px !important;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 15px !important;
    cursor: pointer;
    background-color: #d22525;
    /* 悬浮时背景颜色 */
    color: #fff;
    /* 悬浮时文字颜色 */
  }

  .service2 {
    width: 90px !important;
    height: 85px !important;
    background-color: #fddbdb;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 15px !important;
    margin-left: 6px;
    cursor: pointer;
  }

  .service2:hover {
    width: 90px !important;
    height: 85px !important;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 15px !important;
    margin-left: 6px;
    cursor: pointer;
    background-color: #d22525;
    /* 悬浮时背景颜色 */
    color: #fff;
    /* 悬浮时文字颜色 */
  }


  /* 服务优势 */
  .fuwuyoushi {
    margin-top: 5px;
  }

  .box {
    width: 185px;
    height: 107px;
    background-color: #9bcdff;
    justify-content: center;
    align-items: center;
    margin-left: 2px;
    margin-top: 2px;
    border-radius: 4px;
  }

  .ziyuanheight {
    height: 35px;
  }

  .goodtitle {
    font-size: 15px;
    transform: scaleX(1.3) scaleY(1.7);
    color: #fdfcb8;
    font-weight: 550;
    line-height: 32px;
    font-family:Impact, Haettenschweiler, 'Arial Narrow Bold', sans-serif;
  }

  .goodtext {
    font-size: 13px;
    margin-top: 8px;
  }

  /* 腰线 */
  .yaoxianda {
    width: 100%;
    height: 90px;
    background-color: #000;
    color: white;
    margin-left: auto;
    margin-right: auto;
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    gap: 0px;
    margin-top: 2vh;
    text-align: left;
  }

  .biaoti {
    font-weight: 700;
    font-size: 16px;
    margin-top: -5px;
    line-height: 29px;
  }

  .quanfangwei {
    font-weight: 500;
    font-size: 9px;
    margin-top: -3px;
  }

  .fangxin {
    font-size: 11px;
    color: red;
    font-weight:700;
  }

  .duigou {
    font-size: 9px;
  }

  .duigou1 {
    font-size: 9px;
    margin-top: 4px;
  }

  .duichen {
    margin-left: 22px;
  }

  .rexian {
    font-size: 7px;
  }

  .shoujihao {
    font-size: 9px;
  }

  .hongdise {
    background-color: #b30101;
    color: white;
    font-size: 11px;
    font-weight: 700;
    width: 95px;
    height: 90px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }


  /* 腰线1 */

  .yaoxianda1 {
    width: 100%;
    height: 86px;
    background-color: #000;
    color: white;
    margin-left: auto;
    margin-right: auto;
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    gap: 0px;
    margin-top: 2vh;
    text-align: left;
  }

  .hongdise1 {
    background-color: #b30101;
    color: white;
    font-size: 13px;
    font-weight: 700;
    width: 82px;
    height: 86px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }


  .quanfangwei2 {
    font-weight: 500;
    font-size: 13px;
    margin-top: 0px;
  }

  .quanfangwei1 {
    font-weight: 900;
    font-size: 14px;
    margin-top: 0px;
  }

  .kuandu {
    width: auto;
    margin-left: 20px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: left;
    text-align: left;
    height: 56px;
    margin-top: 0px;
  }

  .biaoti1 {
    font-size: 13px;
    font-weight: 550;
    transform: scaleX(1.3) scaleY(1.8);
    line-height: 28px;
    margin-left: 0px;
    width: 122px;
  }

  .biaoti2 {
    font-size: 13px;
    font-weight: 550;
    transform: scaleX(1.3) scaleY(1.8);
    line-height: 28px;
    margin-left: 0px;
    width: 122px;
  }


  /* 我们的客户 */
  .juzhong {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    margin-top: 5px;
  }

  .kehu {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .kehu1 {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 0px;
    margin-top: 8px;
  }

  .dazi {
    height: 43px;
    width: 120px;
    border: 1px solid black;
    font-size: 18px;
    font-weight: 500;
    display: flex;
    align-items: center;
    justify-content: center;
    border-top-left-radius: 10px;
  }

  .zuoer {
    height: 58px;
    width: 120px;
    border-left: 1px solid black;
    border-right: 1px solid black;
    border-bottom: 1px solid black;
    font-size: 14px;
    margin-top: 0px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-bottom-left-radius: 10px;
    flex-direction: column;
    text-align: left;
  }

  .fangkuai {
    list-style-type: square;
    margin-top: 0px;
    padding-left: 10px;
  }

  .youyi {
    height: 102px;
    width: 160px;
    border-top: 1px solid black;
    border-right: 1px solid black;
    border-bottom: 1px solid black;
    font-size: 15px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-top-right-radius: 10px;
    border-bottom-right-radius: 10px;
    flex-direction: column;
    text-align: left;
  }

  .yuanquan {
    list-style-type: circle;
  }


  /* 成功案例 */
  .carouselcard {
    margin-top: 5px;
  }

  .succ {
    display: flex;
    justify-content: center;
    align-items: center;
    color: #535353;
    gap: 4px;
  }

  .succ1 {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 5px;
    color: #535353;
    gap: 4px;
  }

  .success {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    margin-left: 0px;
    width: 92px;
  }

  .success1 {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    width: 92px;
  }

  .carousel-imagecard {
    height: 99px;
    width: 81px;
    object-fit: fill;
    margin-left: 0px;
    display: block;
  }

  .text {
    font-size: 12px;
    flex-grow: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    margin-bottom: 0px;
    height: 14px;
    margin-top:0px;
  }

  .text1 {
    font-size: 12px;
    flex-grow: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    margin-bottom: 0px;
    height: 14px;
    margin-top:0px;
  }

  .text2 {
    font-size: 9px;
    height: 50px;
    margin-bottom: 2px;
    /* width:70px; */
    font-weight: 700;
    margin-top: 5px;
    line-height: normal;
  }

  .text4 {
    font-weight: 700;
    margin-top: 2px;
    margin-bottom: 2px;
    font-size: 12px;
    height: 33px;
  }

  .text3 {
    font-weight: 700;
    margin-top: 2px;
    margin-bottom: 2px;
    font-size: 12px;
    height: 33px;
  }


  /* 客户的肯定 */
  .kehudegood {
    height: 11vh;
    width: 7vh;
    margin-left: 10px;
  }


  /* 新闻 */
  .newInfo {
    background-image: url(../assets/img/newInfo.jpg);
    background-repeat: no-repeat;
    background-position: top center;
    background-size: 139% 250px;
  }

  .index_ans01 {
    width: 100%;
    margin: 0 auto;
    height: 250px;
  }

  .index_ans02 {
    text-align: center;
    font-size: 12px;
    color: #333;
    /* padding-top: 20px; */
    height: 250px;
  }

  .gengduo {
    margin-top: 7px;
    width: 90%;
  }

  .look {
    display: block;
    width: 29px;
    height: 17px;
    line-height: 17px;
    text-align: center;
    background: #d42828;
    color: #fff;
    font-size: 8px;
    border-radius: 4px;
  }

  .yema {
    margin-top: -2px;
    margin-left: auto;
    margin-right: auto;
  }

  .tableCSS {
    width: 70%;
    overflow: hidden;
    height: auto;
    margin-top: 3px;
    border: 1px solid #ddd;
    border-collapse: collapse;
    font-size: 8px;
    margin-left: 15%;
  }

  .tdCSS1 {
    width: 32px;
    padding: 3px;
    text-align: left;
    border: none;
    font-size: 10px;
  }

  .tdCSS {
    padding: 3px;
    text-align: left;
    border: none;
    font-size: 7px;
  }
}</style>



// WEBPACK FOOTER //
// src/components/index.vue